<template>
	<aside>
		<div class="background"></div>
		<h3>
			How to see the tracking:
		</h3>
		<ul class="services-list">
			<li>
				<router-link to="/how-to-watch-tractrac/">
					<img class="icon" height="22px" :src="`https://tractrac.s3.eu-central-1.amazonaws.com/web/info-solid.svg`" alt="Info Logo" >
					<span>Info and FAQ</span>
					<img class="arrow" width="12px" :src="`https://s3.eu-central-1.amazonaws.com/tractrac/web/long-arrow-alt-right-regular.svg`" alt="Arrow Icon" />
				</router-link>
			</li>
			<li>
				<router-link to="/how-to-watch-tractrac/">
					<img class="icon" height="22px" :src="`https://s3.eu-central-1.amazonaws.com/tractrac/web/html5-brands.svg`" alt="HTML5 Logo" >
					<span>HTML5 Viewer</span>
					<img class="arrow" width="12px" :src="`https://s3.eu-central-1.amazonaws.com/tractrac/web/long-arrow-alt-right-regular.svg`" alt="Arrow Icon" />
				</router-link>
			</li>
			<li>
				<a href="https://play.google.com/store/apps/details?id=com.tractrac.mobile" target=_blank>
					<img class="icon" height="22px" :src="`https://s3.eu-central-1.amazonaws.com/tractrac/web/android-brands.svg`" alt="Android Logo" >
					<span>Android</span>
					<img class="arrow" width="12px" :src="`https://s3.eu-central-1.amazonaws.com/tractrac/web/long-arrow-alt-right-regular.svg`" alt="Arrow Icon" />
				</a>
			</li>
			<li>
				<a href="https://itunes.apple.com/us/app/tractrac/id634370674?ls=1&mt=8" target=_blank>
					<img class="icon" height="22px" :src="`https://s3.eu-central-1.amazonaws.com/tractrac/web/apple-brands.svg`" alt="Apple Logo" >
					<span>iOS</span>
					<img class="arrow" width="12px" :src="`https://s3.eu-central-1.amazonaws.com/tractrac/web/long-arrow-alt-right-regular.svg`" alt="Arrow Icon" />
				</a>
			</li>
		</ul>

		<h3>Tutorials</h3>
		<p class="app"><a target="_blank" :href="tutorialAppUrl">Mobile App</a></p>
		<p class="app google"><a target="_blank" :href="tutorialWebUrl">Web viewer</a></p>

		<h3>Feedback</h3>
		<p class="app google"><a target="_blank" href="mailto:info@tractrac.com">We'd love to <u>hear from you!</u></a></p>

		<Newsletter where="side" />
	</aside>
</template>

<script>
import Newsletter from '@/components/Newsletter.vue'

export default {
	name: 'SidebarEvent',
	components: {
		Newsletter
	},
	props: ['tutorialAppUrl', 'tutorialWebUrl']
}

</script>

<style lang="scss" scoped>

$link: #333;
$hover: #e74c3c;
$blueDark: rgba(0, 90, 132, 1);
$blueLight: rgba(0, 159, 194, 1);
$green: #63b323;
$grey: #9D9D9D;

aside {
	padding: 48px 0 48px 32px;
	position: relative;
	box-sizing: border-box;
	flex-basis: 290px;
	flex-shrink: 0;
}

aside .background {
	background: #E3EDF2;
	position: absolute;
	top: 0;
	width: 500%;
	height: 100%;
	left: 0;
	z-index: -1;
}

aside h3 {
	font-size: 18px;
	margin: 0 0 16px 0;
	font-weight: 500;
	color: $link;
}

aside small {
	display: block;
	margin-top: -12px;
}

aside small a {
	color: $grey;
	font-size: 12px;
    text-decoration: none;
}

aside small a:hover {
	color: $hover;
}

aside .services-list {
	margin-bottom: 36px;
	list-style: none;
	padding: 0;
}

aside .services-list li {
	border-bottom: 1px solid $grey;
	padding: 8px 0;
	color: $grey;
	font-weight: 300;
	cursor: pointer;
	font-size: 14px;
	text-decoration: none;
}

aside .services-list li a {
	color: $grey;
	text-decoration: none;
}

aside .services-list li:last-child {
	border: none;
}

aside .services-list li img.icon {
	vertical-align: middle;
	margin: -2px 12px 0 0;
	transition: transform 0.2s linear;
}

aside .services-list li img.arrow {
	vertical-align: middle;
	margin: 3px 3px 0 0;
	float: right;
	transition: transform 0.2s linear;
}

aside .services-list li span {
	display: inline-block;
	transition: transform 0.2s linear;
}

aside .services-list li.selected span,
aside .services-list li:hover span {
	transform: translateX(9px);
}

aside .services-list li.selected img.icon,
aside .services-list li:hover img.icon {
	transform: translateX(6px);
}

aside .services-list li.selected img.arrow,
aside .services-list li:hover img.arrow {
	transform: translateX(-6px) rotate(-180deg);
}

aside p {
	font-size: 14px;
    line-height: 24px;
    color: $grey;
    font-weight: 300;
}

aside p a {
    color: $grey;
    text-decoration: none;
}

aside p a:hover {
    color: $hover;
}

aside p.app {
	margin: 0;
}

aside #mce-EMAIL {
	width: 100%;
}

aside #mc-embedded-subscribe {
	margin-top: 24px;
}

aside  p.app.google {
	margin-bottom: 36px;
}

@media only screen and (max-width: 480px) {

	aside {
		display: none;
	}

}
</style>
